"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.ttsFields = exports.isSkipped = exports.initialValues = exports.icon = exports.getMetricsPrefix = exports.getMetrics = exports.getDataDefinitions = exports.getDataConnectorsValues = exports.getDataConnectors = exports.fields = exports.errorMessages = void 0;
var _react = _interopRequireDefault(require("react"));
var _isInt = _interopRequireDefault(require("validator/lib/isInt"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var fields = exports.fields = ['question', 'description', 'defaultValue', 'visualType', 'width', 'height', 'inputPrepend', 'inputAddon', 'isRequired', 'validationRule', 'minCharacters', 'maxCharacters', 'minNumber', 'maxNumber', 'regex',
// Error messages
'requiredErrorMessage', 'minCharactersErrorMessage', 'maxCharactersErrorMessage', 'numberErrorMessage', 'minNumberErrorMessage', 'maxNumberErrorMessage', 'emailErrorMessage', 'phoneErrorMessage', 'dateErrorMessage', 'regexErrorMessage', 'isTypeExpanded', 'isRequiredExpanded', 'isValidationExpanded'];
var ttsFields = exports.ttsFields = function ttsFields(_ref) {
  var settings = _ref.settings,
    isMatrixMode = _ref.isMatrixMode;
  return isMatrixMode ? [] : ['question', 'description'];
};
var initialValues = exports.initialValues = {
  question: '<p><strong>What is your opinion about ...?</strong></p>',
  width: '600px',
  height: '60px',
  minCharacters: '100',
  visualType: 'textarea',
  validationRule: 'none',
  requiredErrorMessage: 'An answer is required.',
  minCharactersErrorMessage: 'Fewer than :min characters',
  maxCharactersErrorMessage: 'More than :max characters',
  numberErrorMessage: 'It should be a whole number',
  minNumberErrorMessage: 'It should be greater than or equal to :min',
  maxNumberErrorMessage: 'It should be less than or equal to :max',
  emailErrorMessage: 'It should be a valid email',
  phoneErrorMessage: 'It should be a valid phone',
  dateErrorMessage: 'It should be a date',
  regexErrorMessage: 'Incorrect value',
  isTypeExpanded: true,
  isRequiredExpanded: true,
  isValidationExpanded: true
};
var icon = exports.icon = /*#__PURE__*/_react["default"].createElement("i", {
  className: "glyphicon glyphicon-edit"
});
var errorMessages = exports.errorMessages = {
  noMinAndMaxCharacters: 'You have to specify min or max',
  minCharactersIsNotNumber: 'Value should be a number between 1 and 10000',
  maxCharactersIsNotNumber: 'Value should be a number between 1 and 10000',
  minCharactersMoreThanMax: 'Max should be more than min',
  minNumberMoreThanMax: 'Max should be more than min',
  minNumberIsNotNumber: 'Value should be a whole number',
  maxNumberIsNotNumber: 'Value should be a whole number',
  regextIsRequired: 'Regex is required',
  regextIsWrong: 'Regex is wrong'
};
var validate = exports.validate = function validate(values) {
  var errors = {};
  if (values.validationRule === 'length') {
    if (!values.minCharacters && !values.maxCharacters) {
      errors.minCharacters = errorMessages.noMinAndMaxCharacters;
    }
    if (values.minCharacters && !(0, _isInt["default"])(values.minCharacters, {
      min: 1,
      max: 10000
    })) {
      errors.minCharacters = errorMessages.minCharactersIsNotNumber;
    }
    if (values.maxCharacters && !(0, _isInt["default"])(values.maxCharacters, {
      min: 1,
      max: 10000
    })) {
      errors.maxCharacters = errorMessages.maxCharactersIsNotNumber;
    }
    if (values.minCharacters && values.maxCharacters && !errors.minCharacters && !errors.maxCharacters) {
      if (+values.minCharacters > +values.maxCharacters) {
        errors.maxCharacters = errorMessages.minCharactersMoreThanMax;
      }
    }
  }
  if (values.validationRule === 'number') {
    if (values.minNumber && !(0, _isInt["default"])(values.minNumber)) {
      errors.minNumber = errorMessages.minNumberIsNotNumber;
    }
    if (values.maxNumber && !(0, _isInt["default"])(values.maxNumber)) {
      errors.maxNumber = errorMessages.maxNumberIsNotNumber;
    }
    if (values.minNumber && values.maxNumber && !errors.minNumber && !errors.maxNumber) {
      if (+values.minNumber > +values.maxNumber) {
        errors.maxNumber = errorMessages.minNumberMoreThanMax;
      }
    }
  }
  if (values.validationRule === 'regex') {
    if (!values.regex) {
      errors.regex = errorMessages.regextIsRequired;
    } else if (!/^\/.+\/[a-zA-Z]*$/.test(values.regex)) {
      errors.regex = errorMessages.regextIsWrong;
    }
  }
  return errors;
};
var getMetricsPrefix = exports.getMetricsPrefix = function getMetricsPrefix() {
  return 'tx';
};
var getDataDefinitions = exports.getDataDefinitions = function getDataDefinitions(id, settings) {
  var metricsPrefix = getMetricsPrefix();
  var data = {
    title: (0, _cccisdSurveyCommon.stripTags)(settings.question),
    titleHtml: settings.question,
    type: 'text',
    questionType: 'openEnded',
    variableType: 'qualitative',
    tags: {
      system: ['answer']
    }
  };
  if (settings.validationRule === 'length') {
    if (settings.minCharacters) {
      data.minLength = +settings.minCharacters;
    }
    if (settings.maxCharacters) {
      data.maxLength = +settings.maxCharacters;
    }
  }
  if (settings.validationRule === 'number') {
    data.type = 'number';
    if (settings.minNumber) {
      data.minimum = +settings.minNumber;
    }
    if (settings.maxNumber) {
      data.maximum = +settings.maxNumber;
    }
  }
  return _defineProperty({}, id + '_answer', _objectSpread(_objectSpread({}, data), {}, {
    reportHeader: "".concat(metricsPrefix, "_").concat(id)
  }));
};
var getMetrics = exports.getMetrics = function getMetrics(id, settings, answer) {
  if (answer === undefined) {
    return _defineProperty({}, id + '_answer', null);
  }
  if (settings.validationRule === 'number') {
    return _defineProperty({}, id + '_answer', +answer);
  }
  return _defineProperty({}, id + '_answer', answer);
};
var getDataConnectors = exports.getDataConnectors = function getDataConnectors(settings) {
  var connectors = {};
  if (settings.validationRule === 'number') {
    connectors.number = {
      type: 'number',
      title: 'Number'
    };
  } else {
    connectors.text = {
      type: 'string',
      title: 'Text'
    };
  }
  return connectors;
};
var getDataConnectorsValues = exports.getDataConnectorsValues = function getDataConnectorsValues(settings, answer) {
  return {
    text: function text() {
      return answer;
    },
    number: function number() {
      return +answer;
    }
  };
};
var isSkipped = exports.isSkipped = function isSkipped(_ref6) {
  var settings = _ref6.settings,
    answer = _ref6.answer;
  return !answer;
};